var Avatar_module_default = {
	avatar: "_avatar_va14e_8",
	image: "_image_va14e_43",
	"avatar-imageless": "_avatar-imageless_va14e_55",
	"stacked-avatars": "_stacked-avatars_va14e_109",
	"clip-path": "_clip-path_va14e_128"
};
//#endregion
export { Avatar_module_default as default };

//# sourceMappingURL=Avatar.module.js.map